import { Component, EventEmitter, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from '../enums';
import { SharedService } from '../shared-service.service';

@Component({
    selector: 'app-shared-add-remark',
    templateUrl: './shared-add-remark.component.html',
    styleUrls: ['./shared-add-remark.component.scss'],
    standalone: false
})
export class SharedAddRemarkComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  protected enums = inject(Enums);

  remark: string;
  disabledSubmit = false;
  title: string;

  @Output() passEntry = new EventEmitter<any>();

  submit() {
    if (this.remark == undefined || this.remark == "")
      this.sharedService.openAlert("Please key in your remark to proceed!", ALERT_TYPE.DANGER);
    else
      this.passEntry.emit(this.remark);

    this.activeModal.close();
  }

  reset() {
    this.remark = "";
    this.activeModal.close();
  }
}
